import { styled } from '@mui/material/styles';
import { Box, Grid, Card, Radio, FormControlLabel } from '@mui/material';

/** Full-width content area; page padding lives on UserProfileInfoPage. */
export const PageContainer = styled(Box)({
    flex: 1,
    width: '100%',
});

export const StyledGrid = styled(Grid)({
    gap: 16,
});

export const StyledCard = styled(Card)(({ theme }) => ({
    marginTop: 0,
    padding: 12,
    borderRadius: 12,
    boxShadow: 'none',
    border: '1px solid',
    borderColor: theme.palette.divider,
}));

export const CardContentBox = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
});

export const FieldBox = styled(Box)({
    marginTop: 6,
});

export const StyledRadio = styled(Radio)({
    color: '#002F87',
    '&.Mui-checked': {
        color: '#002F87',
    },
    opacity: 1,
});

export const StyledFormControlLabel = styled(FormControlLabel)({
    color: '#000000',
    '& .MuiFormControlLabel-label': {
        color: '#000000',
        fontSize: '0.9rem',
    },
});